var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticStyle:{"width":"90%","font-size":"75%"}},[_vm._v("Got Token: "+_vm._s(_vm.jwt))]),_c('code',[_vm._v(_vm._s(_vm.tokenInfo))])])}
var staticRenderFns = []

export { render, staticRenderFns }